/**
 * @generated SignedSource<<305dc7aa45f26b6b406fc962aba7f607>>
 * @relayHash 94c9b01a38450e035b8b9eacd84cf9e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0ed954688ed8e457d933100d3b4e1720e9c4e7f3022b071b7e794744efb2186

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_getArchivedIssuesFilterOptionsQuery$variables = {
  projectId: string;
};
export type main_getArchivedIssuesFilterOptionsQuery$data = {
  readonly jira: {
    readonly getArchivedIssuesFilterOptions: {
      readonly " $fragmentSpreads": FragmentRefs<"archivedByFilter_issueArchivalArchives" | "issueTypeFilter_issueArchivalArchives" | "reporterFilter_issueArchivalArchives">;
    } | null | undefined;
  } | null | undefined;
};
export type main_getArchivedIssuesFilterOptionsQuery = {
  response: main_getArchivedIssuesFilterOptionsQuery$data;
  variables: main_getArchivedIssuesFilterOptionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "projectId",
    "variableName": "projectId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v6 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 16
  }
],
v8 = [
  {
    "concreteType": "JiraUserEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "picture"
          },
          (v4/*: any*/)
        ]
      },
      (v5/*: any*/)
    ]
  },
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "main_getArchivedIssuesFilterOptionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraArchivedIssuesFilterOptions",
            "kind": "LinkedField",
            "name": "getArchivedIssuesFilterOptions",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "issueTypeFilter_issueArchivalArchives"
              },
              {
                "kind": "FragmentSpread",
                "name": "reporterFilter_issueArchivalArchives"
              },
              {
                "kind": "FragmentSpread",
                "name": "archivedByFilter_issueArchivalArchives"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "main_getArchivedIssuesFilterOptionsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraArchivedIssuesFilterOptions",
            "kind": "LinkedField",
            "name": "getArchivedIssuesFilterOptions",
            "plural": false,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 7
                  }
                ],
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "issueTypeId"
                          },
                          (v2/*: any*/),
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "medium"
                              }
                            ]
                          },
                          {
                            "concreteType": "JiraIssueTypeHierarchyLevel",
                            "kind": "LinkedField",
                            "name": "hierarchy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "level"
                              },
                              (v2/*: any*/)
                            ]
                          },
                          (v4/*: any*/)
                        ]
                      },
                      (v5/*: any*/)
                    ]
                  },
                  (v6/*: any*/)
                ],
                "storageKey": "issueTypes(first:7)"
              },
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "reporters",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "reporters(first:16)"
              },
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "archivedBy",
                "plural": false,
                "selections": (v8/*: any*/),
                "storageKey": "archivedBy(first:16)"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b0ed954688ed8e457d933100d3b4e1720e9c4e7f3022b071b7e794744efb2186",
    "metadata": {},
    "name": "main_getArchivedIssuesFilterOptionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "b02eec471fa1758425d0f3d68d9a1be0";

export default node;
